import { AuthService } from '../service/auth.service';
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { LoaderService } from '../../loader/loader.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
	constructor(
		private authenticationService: AuthService,
		private loaderService: LoaderService,
		private ngxLoader: NgxUiLoaderService,
		private snackBar: MatSnackBar,
		private router: Router
	) { }

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		// this.loaderService.isLoading.next(true);
		this.ngxLoader.start();
		return next.handle(request).pipe(
			catchError((err) => {
				if (err.status === 401) {
					// auto logout if 401 response returned from api


					this.authenticationService.logout();
					location.reload(true);




				} else if (err.status === 500) {
					this.snackBar.open('Something went wrong.', '', {
						duration: 2000,
						verticalPosition: 'top',
						horizontalPosition: 'center',
						panelClass: 'snackbar-danger'
					});
				}

				const error = err.error.message || err.statusText;
				return throwError(err.error.error);
			}),
			finalize(() => {
				this.ngxLoader.stop();
				// this.loaderService.isLoading.next(false);
			})
		);
	}
}
